import type { EPresetOption } from "app/common/keyword-research/website-keywords/competitiveFilterPresets";

/*eslint-disable @typescript-eslint/naming-convention */
export interface IIntentDistributionData {
    Informational: number;
    Navigational: number;
    Local: number;
    Job_Search: number;
    Transactional: number;
}
export interface ISummaryData {
    UniqueKeywords: number;
    UniquePages: number;
    Ads: number;
}
export interface IResponseData extends ISummaryData {
    TrafficDistribution: ITrafficDistributionData;
    IntentDistribution: IIntentDistributionData;
}
export interface ITrafficDistributionDataItem {
    Share: number;
    Change: number;
}
export interface ITrafficDistributionSearchResponseData {
    Organic: ITrafficDistributionDataItem;
    Paid: ITrafficDistributionDataItem;
}
export interface ITrafficDistributionBrandedResponseData {
    Branded: ITrafficDistributionDataItem;
    NonBranded: ITrafficDistributionDataItem;
}
export interface ITrafficDistributionData {
    Branded: ITrafficDistributionBrandedResponseData;
    Search: ITrafficDistributionSearchResponseData;
}
/* eslint-enable @typescript-eslint/naming-convention */

interface ITrendData {
    ads: number;
    uniqueKeywords: number;
    uniquePages: number;
}
interface ITrendsData {
    [date: string]: ITrendData;
}
export interface ISummaryTrendsData {
    trends: ITrendsData;
}
interface IRankDistributionOverTimeKeywordDistributionData {
    keywordCount: number;
    totalKeywords: number;
    share: number;
    change?: number;
}
export enum KeywordDistributionGroup {
    Group1To3 = "1-3",
    Group4To10 = "4-10",
    Group11To20 = "11-20",
    Group21To50 = "21-50",
    Other = "other",
}
type IRankDistributionOverTimeMonthlyDistributionData = Record<
    KeywordDistributionGroup,
    IRankDistributionOverTimeKeywordDistributionData
>;
export interface IRankDistributionOverTimeData {
    country: number;
    monthlyDistributions: {
        [date: string]: IRankDistributionOverTimeMonthlyDistributionData;
    };
}
export interface IRankDistributionOpportunitiesData {
    country: number;
    data: IRankDistributionOverTimeMonthlyDistributionData;
}

export interface IAPIParams {
    to: string;
    from: string;
    isWindow: boolean;
    country: string;
    webSource: string;
    keys: string;
    includeSubDomains: boolean;
    device: string;
    pageFilterJson: object;
    getLastThirteenMonths?: boolean;
}
export interface ICompetitiveOpportunitiesData {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    TotalPresets: Record<EPresetOption, number>;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Total: number;
}
